export default build =>
    build.mutation({
        query(payload) {
            console.log("payload indelete lesson",payload)
            return {
                url: '/course/deleteCourse',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['allCourses'],
       
    })
